import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute default fresh data
      gcTime: 1000 * 60 * 5, // 5 minutes in memory after becoming inactive
      refetchOnWindowFocus: true, // Keep ERP numbers fresh when user returns to tab
      retry: 1, // Only retry once on network error
    },
    mutations: {
      retry: 0,
    },
  },
})
